import PropTypes from "prop-types";
import {useCallback, useState} from "react";
import * as React from "react";
import {useForm} from "react-hook-form";
import {InvisibleSmartCaptcha} from "@yandex/smart-captcha";
import Button from "../UI/Button";
import * as formStyles from "./form.module.css";

const Form = ({fields, buttonText, note, moreButtons, onSubmit: clientOnSubmit}) => {
    const {
        formState: {errors},
        handleSubmit,
        ...restHookData
    } = useForm({
        defaultValues: fields.reduce((acc, {name, value = ""}) => ({...acc, [name]: value}), {}),
    });

    const [formData, setFormData] = useState({});
    const [formPending, setFormPending] = useState(false);
    const [captchaVisible, setCaptchaVisible] = useState(false);

    const handleChallengeHidden = useCallback(() => setCaptchaVisible(false), []);

    const onCaptchaSuccess = useCallback(
        async (token) => {
            setFormPending(true);
            await clientOnSubmit({...formData, token});
            setFormPending(false);
        },
        [formData, clientOnSubmit],
    );

    const onSubmit = useCallback(
        async (data) => {
            if (typeof clientOnSubmit === "function") {
                setFormData(data);
                setCaptchaVisible(true);
            }
        },
        [clientOnSubmit],
    );

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className={formStyles.form} noValidate>
                <div>
                    {fields.map((field, idx) => field.render({error: errors[field.name], key: idx, ...restHookData}))}
                    {note}
                </div>
                <div>
                    {moreButtons}
                    <Button variant="primary" type="submit" loading={formPending}>
                        {buttonText}
                    </Button>
                </div>
            </form>
            {process.env.NODE_ENV !== "development" && (
                <InvisibleSmartCaptcha
                    sitekey="ysc1_bzAg5rLbCNKkpaqoU5MHhUEpkkUpw5leLNpAT4a3940060cb" // {process.env.YANDEX_CAPTCHA_CLIENT_KEY}
                    onSuccess={onCaptchaSuccess}
                    onChallengeHidden={handleChallengeHidden}
                    visible={captchaVisible}
                />
            )}
        </>
    );
};

Form.defaultProps = {
    buttonText: "Отправить",
};

Form.propTypes = {
    fields: PropTypes.arrayOf(
        PropTypes.exact({
            name: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.array]),
            render: PropTypes.func.isRequired,
        }),
    ).isRequired,
    buttonText: PropTypes.string,
    note: PropTypes.element,
    moreButtons: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
    onSubmit: PropTypes.func,
};

export default Form;
